import { createSlice } from "@reduxjs/toolkit";

const AUTH_KEYS = { USER: "user", TOKEN: "accessToken" };

const safeLoadAuth = () => {
  try {
    const raw = localStorage.getItem(AUTH_KEYS.USER);
    const user = raw ? JSON.parse(raw) : null;
    const token = localStorage.getItem(AUTH_KEYS.TOKEN);
    return { user, token };
  } catch {
    return { user: null, token: null };
  }
};

const { user: storedUser, token: storedToken } = safeLoadAuth();

const initialState = {
  user: storedUser,
  accessToken: storedToken,
  isAuthenticated: !!storedToken,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    /* -------------------------
       REQUEST
    -------------------------- */
    authRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    /* -------------------------
       LOGIN SUCCESS ONLY
    -------------------------- */
    authSuccess: (state, action) => {
      const { user, accessToken } = action.payload;

      state.user = user;
      state.accessToken = accessToken;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;

      try {
        localStorage.setItem(AUTH_KEYS.USER, JSON.stringify(user));
        localStorage.setItem(AUTH_KEYS.TOKEN, accessToken);
      } catch (e) {
        console.warn("Auth persist failed:", e);
      }
    },

    /* -------------------------
       ERROR
    -------------------------- */
    authFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    /* -------------------------
       STOP LOADING (register / verify / forgot)
    -------------------------- */
    stopLoading: (state) => {
      state.loading = false;
    },

    /* -------------------------
       CLEAR ERROR
    -------------------------- */
    clearAuthError: (state) => {
      state.error = null;
    },

    /* -------------------------
       LOGOUT
    -------------------------- */
    logout: (state) => {
      state.user = null;
      state.accessToken = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;

      try {
        localStorage.removeItem(AUTH_KEYS.USER);
        localStorage.removeItem(AUTH_KEYS.TOKEN);
      } catch {}
    },
  },
});

export const {
  authRequest,
  authSuccess,
  authFail,
  stopLoading,
  clearAuthError,
  logout,
} = authSlice.actions;

export default authSlice.reducer;
